import { apiFetch } from './api';

export type JobStatus = 'dead' | 'pending' | 'running' | 'done';

export interface JobRow {
  id: string;
  queue: string;
  payload: unknown;
  idempotencyKey: string | null;
  status: JobStatus;
  attempts: number;
  maxAttempts: number;
  /** 0 = most urgent, 9 = least (server/src/jobs/priority.ts). */
  priority: number;
  /** Site the job works for; null for platform work. */
  siteId: string | null;
  runAt: string;
  lastError: string | null;
  createdAt: string;
  updatedAt: string;
  finishedAt: string | null;
}

export interface JobCount {
  queue: string;
  status: JobStatus;
  count: number;
}

const base = '/api/admin/jobs';

export const listJobs = (status: JobStatus) =>
  apiFetch<{ jobs: JobRow[] }>(`${base}?status=${status}`).then((r) => r.jobs);

export const jobSummary = () => apiFetch<{ counts: JobCount[] }>(`${base}/summary`).then((r) => r.counts);

export const retryJob = (id: string) =>
  apiFetch<{ ok: boolean }>(`${base}/${id}/retry`, { method: 'POST' });

export const discardJob = (id: string) =>
  apiFetch<{ ok: boolean }>(`${base}/${id}`, { method: 'DELETE' });

/** Replay every dead job (or one queue's). Returns how many were requeued. */
export const retryAllDead = (queue?: string) =>
  apiFetch<{ ok: boolean; replayed: number }>(`${base}/retry-all${queue ? `?queue=${encodeURIComponent(queue)}` : ''}`, {
    method: 'POST',
  });
